var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eduMap"},[_c('iframe',{attrs:{"src":"https://project.zhuneng.cn/d3mdoc/#/iframe?id=5da320f59da64fc6bc86b5ac454abbdf","frameborder":"0"}})])
}]

export { render, staticRenderFns }